import { render, staticRenderFns } from "./ModalServicesComponents.vue?vue&type=template&id=6f17630f&"
import script from "./ModalServicesComponents.vue?vue&type=script&lang=js&"
export * from "./ModalServicesComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports